import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2f4gf52uef: FaireBrandEntity = {
  token: "b_2f4gf52uef",
  type: "brand",
  name: "Calie Paris",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff75bb3bcf7e43fd5623f667099a63fd844913daafb33e43b59cc141d5bb310f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6f32f56cb0152eec3c526f471ed4b97344cccaf3a466056c56f3a8d9d0b53d32.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ff75bb3bcf7e43fd5623f667099a63fd844913daafb33e43b59cc141d5bb310f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6f32f56cb0152eec3c526f471ed4b97344cccaf3a466056c56f3a8d9d0b53d32.jpeg",
  location: "Paris, FRA",
  minimumOrderDollars: 155,
  rating: 4.9,
  reviewCount: 73,
  isTopShop: true,
  isInsider: false,
  description:
    "Au commencement, la force d’un couple fusionnel et une idée qui grandit dans leur tête de jeunes rêveurs : celle de concrétiser leur envol. Marqués par un projet commun, ils imaginent une marque qui les représente et, pour les femmes, des pièces de saison qui leur permettent d’affirmer leur féminité et de se sentir belles au quotidien. La marque propose des collections modernes sous influence parisienne, car c’est de leur quotidien dans la capitale française que le couple puise une partie de leurs inspirations. Les créations imaginées sont un moyen pour eux d’exprimer leur vision, un hommage à leur amour et la rencontre de leurs pensées.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:45.872Z",
    importedBy: "entity-db-cli",
  },
};
